import React from "react";
import { Card, Row, Col, Typography, Select, Button, Form, Input, DatePicker } from "antd";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";

const { Text } = Typography;
const { Option } = Select;

const JW_GenDC = () => {
  const navigate = useNavigate(); 

  return (
     <Card style={{ margin: 24 }}>
        
        <Row justify="space-between" align="middle" style={{ marginBottom: 16 }}>
          <Col>
            <Text strong style={{ fontSize: 14 }}>
              Delivery Challan — Jobwork Issue
            </Text>
          </Col>
          <Col>
           <span style={{ fontWeight: 400 }}>MSPC: </span>
            <Select defaultValue="KARWAR" style={{ width: 120, marginRight: 10 }}>
              <Option value="KARWAR">KARWAR</Option>
            </Select>
             <span style={{ fontWeight: 400 }}>Month: </span>
            <Select defaultValue="Aug 2025" style={{ width: 120, marginRight: 10 }}>
              <Option value="Aug 2025">Aug 2025</Option>
            </Select>
            <Button style={{ marginRight: 8 }}>Load POs</Button>
            <Button>Load Draft</Button>
             <Col>
            <Button type="default" style={{ marginLeft:45,marginTop:10 }}>Save Draft</Button>
        </Col>
          </Col>
        </Row>
 {/* Step Title */}
      <Row>
        <Col>
          <Text strong>Step 3 — Transport Details</Text>
        </Col>
      </Row>
      {/* Step Buttons */}
     <Row gutter={8} style={{ marginBottom: 16 ,justifyContent:"space-between"}}>
          <Col>
            <Button disabled>1. Select PO & RM</Button>
          </Col>
          <Col>
            <Button disabled>2. Pack & Weigh (Bags)</Button>
          </Col>
          <Col>
            <Button type="primary">3. Transport</Button>
          </Col>
          <Col>
            <Button disabled>4. Review & Generate</Button>
          </Col>
        
        </Row>

      {/* Form Rows */}
      <Form layout="vertical" style={{ marginTop: 16 }}>
        <Row gutter={24}>
          <Col span={8}>
            <Form.Item label="Vehicle / Truck No">
              <Input defaultValue="KA-01-0223" />
            </Form.Item>
          </Col>
          <Col span={8} >
            <Form.Item label="Driver Name / Phone">
              <Input defaultValue="90989 90989" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={8}>
            <Form.Item label="Transporter">
              <Input defaultValue="SHIVA TRANSPORT" />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Dispatch Date & Time">
              <DatePicker
                showTime
                style={{ width: "100%" }}
                format="DD-MM-YYYY HH:mm"
                defaultValue={dayjs("2025-09-10 18:32", "YYYY-MM-DD HH:mm")}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={8}>
            <Form.Item label="LR / DO No">
              <Input defaultValue="Nil" />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Origin → Destination">
              <Input defaultValue="MSPC-SHIVAMILLS" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={8}>
            <Form.Item label="e-Way Bill (optional)">
              <Select defaultValue="YES">
                <Option value="YES">YES</Option>
                <Option value="NO">NO</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Remarks">
              <Input placeholder="Any additional note" />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24} style={{ textAlign: "right" }}>
            <Button
              type="primary"
              size="large"
              style={{ width: 140 }}
              onClick={() => navigate("/jobwork/jobwork_dc/jw_reviewdc")} 
            >
              Review
            </Button>
          </Col>
        </Row>
      </Form>
    </Card>
  );
};

export default JW_GenDC;
